import { BlockTime } from "./BlockPosition.js";

class TimeSignature {
    constructor(jsonStructure) {
        this.num_of_beats = jsonStructure.num_of_beats;
        this.note_value = jsonStructure.note_value;
    }
}

export class TimeSignatureObject {
    constructor(jsonStructure) {
        this.start_time = new BlockTime(jsonStructure.start_time);
        this.time_signature = new TimeSignature(jsonStructure.time_signature);
    }
}